import { useEffect, useRef } from 'react';

export const useOverrideLog = () => {
  const warnExceptions = useRef<string[]>([
    'React Router Future Flag Warning:',
    'Selector unknown returned a different',
    `'message' handler took`,
  ]);
  const errorExceptions = useRef<string[]>(['Unsupported vendor-prefixed style property']);

  const overrideConsoleWarn = () => {
    const originalMethod = console.warn;
    console.warn = (...args: any[]) => {
      const message = args?.[0]?.toString?.() ?? '';

      const shouldSuppress = warnExceptions.current.some((exception) => message.includes(exception));

      if (!shouldSuppress) {
        originalMethod(...args);
      }
    };
  };

  const overrideConsoleError = () => {
    const originalMethod = console.error;
    console.error = (...args: any[]) => {
      const message = args?.[0]?.toString?.() ?? '';

      const shouldSuppress = errorExceptions.current.some((exception) => message.includes(exception));

      if (!shouldSuppress) {
        originalMethod(...args);
      }
    };
  };

  useEffect(() => {
    if (import.meta.env.VITE_SHOW_LOG_EXCEPTIONS !== 'true') {
      overrideConsoleWarn();
      overrideConsoleError();
    }
  }, []);
};
